(function () {
  if (window.in8syncCheckoutBridgeLoaded) {
    return;
  }

  window.in8syncCheckoutBridgeLoaded = true;

  const ENDPOINT = 'https://demo.in8sync.com/qty-app-fastaid/ajax.php';
  let checkoutInProgress = false;

  const isCheckoutButton = (element) => {
    return Boolean(element && element.closest('button[name="checkout"], input[name="checkout"], #app_wholesale_price, .mini_cart_checkout'));
  };

  const getCustomerId = () => {
    if (window.in8syncCustomerId) {
      return window.in8syncCustomerId;
    }

    try {
      const id = window.ShopifyAnalytics?.meta?.page?.customerId;
      if (id) return id;
    } catch (error) {}

    try {
      const id = window.meta?.page?.customerId;
      if (id) return id;
    } catch (error) {}

    try {
      const id = window._st?.cid;
      if (id) return id;
    } catch (error) {}

    try {
      const id = window.ShopifyAnalytics?.lib?.user?.().traits?.().uniqToken;
      if (id) return id;
    } catch (error) {}

    return null;
  };

  const appendParam = (params, key, value) => {
    if (value === undefined || value === null) {
      params.append(key, '');
      return;
    }

    if (Array.isArray(value)) {
      value.forEach((item, index) => appendParam(params, `${key}[${index}]`, item));
      return;
    }

    if (typeof value === 'object') {
      Object.keys(value).forEach((childKey) => appendParam(params, `${key}[${childKey}]`, value[childKey]));
      return;
    }

    params.append(key, String(value));
  };

  const encodePayload = (payload) => {
    const params = new URLSearchParams();
    Object.keys(payload).forEach((key) => appendParam(params, key, payload[key]));
    return params.toString();
  };

  const setButtonLoading = (button, loading) => {
    if (!button) return;

    button.toggleAttribute('aria-busy', loading);
    button.disabled = loading;
  };

  const createDraftCheckout = async (button) => {
    if (checkoutInProgress) {
      return;
    }

    checkoutInProgress = true;
    setButtonLoading(button, true);

    try {
      const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json'
        }
      });

      if (!cartResponse.ok) {
        throw new Error(`Cart request failed: ${cartResponse.status}`);
      }

      const cartData = await cartResponse.json();
      if (window.in8syncCustomerApproved === false) {
        window.location.href = window.Shopify?.routes?.root ? `${window.Shopify.routes.root}cart` : '/cart';
        return;
      }

      const customerId = getCustomerId();

      if (!customerId) {
        window.location.href = `/account/login?return_url=${encodeURIComponent('/cart')}`;
        return;
      }

      const payload = {
        action: 'create_cart_order',
        shop: window.Shopify?.shop || window.location.hostname,
        cart_data: cartData,
        customer_id: customerId,
        coupon_code: document.querySelector('input[name="coupon_code"]')?.value || '',
        po_number: document.querySelector('input[name="attributes[ponumber]"]')?.value || ''
      };

      const draftResponse = await fetch(ENDPOINT, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        body: encodePayload(payload)
      });

      const responseText = await draftResponse.text();
      const response = JSON.parse(responseText);

      if (response.result === 'success' && response.invoice_url) {
        window.location.href = response.invoice_url;
        return;
      }

      if (response.result === 'fail' && response.default === 'true') {
        window.location.href = '/checkout';
        return;
      }

      window.location.href = '/checkout';
    } catch (error) {
      console.error('In8sync checkout failed', error);
      checkoutInProgress = false;
      setButtonLoading(button, false);
    }
  };

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest('button[name="checkout"], input[name="checkout"], #app_wholesale_price, .mini_cart_checkout');

      if (!button) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
      createDraftCheckout(button);
    },
    true
  );

  document.addEventListener(
    'submit',
    (event) => {
      const submitter = event.submitter;

      if (!isCheckoutButton(submitter)) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
      createDraftCheckout(submitter);
    },
    true
  );
})();
